import styled from 'styled-components';
import StopsDetails from './StopsDetails';
import { colorSchema } from 'utils/style';

export default styled(StopsDetails)`
  width: 100%;
  .stops-details {
    display: flex;
    flex-direction: column;
    padding: 2.4rem 2rem;

    &__container {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
      width: 100%;
    }

    &__item {
      background-color: ${colorSchema('white')};
      border-radius: 2px;
      box-shadow: 0 0 10px 0 rgba(207, 211, 217, 0.53);
      margin-bottom: 1.6rem;
    }

    &__block {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      padding: 2.5rem;

      &--small {
        flex-basis: 20%;
        max-width: 300px;
      }

      &--big {
        flex-basis: 30%;
      }

      &--dashed {
        border-left: 1px dashed ${colorSchema('grey300')};
      }
    }

    &__block-title {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      margin-bottom: 1.6rem;
    }

    &__date-time {
      display: flex;
      font-size: 1.6rem;
      color: ${colorSchema('grey900')};
      margin-bottom: 0.8rem;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 1rem;
    }

    &__stops-container {
      align-items: center;
      display: flex;
    }

    &__stops {
      font-weight: bold;
      margin-right: 2rem;
    }

    &__distance {
      font-weight: 500;
      text-decoration: underline;
    }

    &__body {
      display: flex;
    }

    &__icon {
      margin-right: 0.5rem;

      &--dark {
        svg {
          fill: ${colorSchema('grey700')};
        }
      }
    }

    &__status {
      margin-top: 1rem;
    }

    &__handling {
      padding: 1.6rem;

      svg {
        fill: ${colorSchema('grey500')};
      }
    }

    &__address-line {
      font-weight: 500;
    }

    &__address-link {
      color: ${colorSchema('primary')};

      &:hover {
        text-decoration: underline;
      }
    }

    &__date {
      color: ${colorSchema('grey900')};
    }

    &__separator {
      color: ${colorSchema('grey900')};
      margin: 0 0.5rem;
    }

    &__time {
      .time-display {
        color: ${colorSchema('grey900')};
        font-weight: normal;
      }
    }

    &__company-name {
      font-weight: bold;
      margin-bottom: 0.5rem;
      text-transform: uppercase;
    }

    &__company-contact {
      color: ${colorSchema('grey900')};
      font-weight: 500;
      margin-bottom: 0.5rem;
    }

    &__ask-label {
      font-weight: bold;
    }

    &__ref {
      margin-bottom: 0.8rem;
    }

    &__ref-title,
    &__ref-text {
      font-size: 1.6rem;
    }

    &__ref-title {
      color: ${colorSchema('grey700')};
    }

    &__comments {
      position: relative;
    }

    &__comments-text {
      color: ${colorSchema('grey900')};
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      position: relative;
    }

    &__comments-button {
      border: 0;
      background: none;
      color: ${colorSchema('grey700')};
      cursor: pointer;
      text-decoration: underline;
      font-size: 1.4rem;
      margin-top: 1rem;
      outline: none;
      padding: 0;
    }

    &__comments-tooltip {
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      display: flex;
      position: absolute;
      background: ${colorSchema('white')};
      padding: 1rem;
      border-radius: 4px;
      left: -50%;
      top: 110%;
      z-index: 1;
    }
  }
`;
